// AKM POC §5.15 — Devam Paneli renkleri (spec §5.15, dataviz doğrulayıcısından geçti, açık zemin).
//
// Doğrulayıcı (plan yazılırken koşuldu): üç seri #2a78d6, #eda100, #4a3aa7 → ALL PASS (komşu CVD ΔE 31,5; amber
// kontrastı 2,11:1 → WARN). Dört renk birlikte (--pairs all) → FAIL (#eb6834 ↔ #eda100 normal görüş ΔE 13,7 < 15).
// KURAL: Eksik rengi (#eb6834) YALNIZ KPI kutusu kenarında kullanılır — Erken (#eda100) ile AYNI GRAFİĞE ASLA girmez.
// Amber düşük kontrastlı → lejant HER ZAMAN görünür; Günlük Eğilim ve Departmana Göre kartlarında tablo görünümü var.

// Seri sırası sabit: late, early, absent (renk varlığı izler, sırayı değil).
export const SERIES = { late: '#2a78d6', early: '#eda100', absent: '#4a3aa7' };
export const SERIES_ORDER = ['late', 'early', 'absent'];

export const KPI_ACCENTS = {
  rate: '#067647', late: '#2a78d6', early: '#eda100', absent: '#4a3aa7', undertime: '#eb6834',
};

// Değişim tonu: kötüleşme / iyileşme / nötr (durum renkleri — ok ikonu + metinle, renk tek başına anlam taşımaz).
export const DELTA = { good: '#067647', bad: '#B42318', neutral: '#6B7280' };

export const SHADE = '#F1F4F8';      // hafta sonu / tatil gölgesi
export const GRID = '#EEF1F5';       // ızgara ve eksen — düz, kesikli DEĞİL
export const CROSSHAIR = '#9CA3AF';  // ipucu imleci — 1px düz

export const SEVERITY = {
  critical: { bg: '#FEE4E2', fg: '#B42318' },
  warning: { bg: '#FEF0C7', fg: '#93370D' },
  info: { bg: '#E8F4FD', fg: '#1c5cab' },
};

// Kart DOM kimlikleri (test + PNG).
export const CARD_IDS = {
  kpi: 'att-kpi',
  trend: 'att-trend',
  departments: 'att-departments',
  lateDistribution: 'att-late-distribution',
  topLate: 'att-top-late',
  topUndertime: 'att-top-undertime',
  bradford: 'att-bradford',
  warnings: 'att-warnings',
};
